// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** Check Login Status (检查登录状态) 检查管理员登录状态 GET /api/auth/check */
export async function checkLoginStatus(options?: { [key: string]: any }) {
  return request<API.ResultMapStringObject>("/api/auth/check", {
    method: "GET",
    ...(options || {}),
  });
}

/** Check Permission (检查权限) 检查当前管理员是否具有指定权限，返回 true 或 false GET /api/auth/check-permission */
export async function checkPermission(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.checkPermissionParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultBoolean>("/api/auth/check-permission", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Check Permissions (批量检查权限) 检查当前管理员是否具有指定的多个权限，返回权限标识与检查结果的映射 POST /api/auth/check-permissions */
export async function checkPermissions(
  body: string[],
  options?: { [key: string]: any }
) {
  return request<API.ResultMapStringBoolean>("/api/auth/check-permissions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Get Admin Info (获取管理员信息) 获取当前登录管理员信息 GET /api/auth/info */
export async function getAdminInfo(options?: { [key: string]: any }) {
  return request<API.ResultMapStringObject>("/api/auth/info", {
    method: "GET",
    ...(options || {}),
  });
}

/** Admin Login (管理员登录) 管理员账号密码登录，需要通过 reCAPTCHA v2 验证和IP白名单检查（如果启用） POST /api/auth/login */
export async function adminLogin(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.adminLoginParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultMapStringObject>("/api/auth/login", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Admin Logout (管理员退出) 管理员退出登录 POST /api/auth/logout */
export async function adminLogout(options?: { [key: string]: any }) {
  return request<API.ResultString>("/api/auth/logout", {
    method: "POST",
    ...(options || {}),
  });
}
